module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalBase', [_c('h1', {
    staticClass: "title-modal"
  }, [_vm._v(_vm._s(_vm.$t("change.selectBrand")))]), _vm._v(" "), _c('swiper', {
    ref: "mySwiper",
    staticClass: "fd-r fw-w m-jc-sb",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "flexContainer logoContainer jc-c fd-r fw-w m-jc-sb"
  }, _vm._l((_vm.brands), function(brand) {
    return _c('div', {
      key: brand.id,
      staticClass: "brandWrap flexContainer jc-c size1of4"
    }, [_c('div', {
      staticClass: "brandLogo flexContainer",
      class: brand.theme,
      on: {
        "click": function($event) {
          _vm.setCurrentBrand(brand)
        }
      }
    }, [_c('img', {
      staticClass: "imgBrand pointer",
      attrs: {
        "src": ("" + _vm.brandImageUrl + (brand.imgPath) + (brand.logo)),
        "alt": brand.name
      }
    })])])
  }))])], 1), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a27d174","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/ModalBrand.vue
// module id = 3002
// module chunks = 0